// #642 Phase 2 Request 6: "Credit on account: $170.00" for the FAMILY (their invoices page and the
// invoice detail), with the part being refunded and the school's terms line. Renders nothing when
// the family holds no credit, so callers can mount it unconditionally.
import { Box, Typography } from '@mui/material';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import type { ParentFamilyCredit } from '../../api/invoices.api';
import { formatCurrencyFromDollars } from '../../utils/currency';

interface CreditOnAccountNoticeProps {
  credit: ParentFamilyCredit | undefined;
}

export default function CreditOnAccountNotice({ credit }: CreditOnAccountNoticeProps) {
  const balance = credit ? parseFloat(credit.balance) : 0;
  if (!credit || !(balance > 0)) return null;
  const refundDue = parseFloat(credit.refundDue);
  return (
    <Box
      data-testid="credit-on-account"
      sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start', p: 1.5, bgcolor: 'rgba(150, 218, 201, 0.25)', borderRadius: 1 }}
    >
      <AccountBalanceWalletIcon sx={{ color: 'primary.main', mt: 0.25 }} />
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontWeight: 600 }}>Credit on account: {formatCurrencyFromDollars(balance)}</Typography>
        {refundDue > 0 && (
          <Typography variant="body2" color="text.secondary">
            {formatCurrencyFromDollars(refundDue)} of it is being refunded
          </Typography>
        )}
        {credit.termsLine && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
            {credit.termsLine}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
